module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTDw2NTw2Njw2NT02NT8/Lzs2NDw2NT8vLz8/Pz03NiYX5lkAAAAKdFJOUwDmaIC/EEi/EBD9P0wdAAAAbUlEQVQ4y2NgoB8QxGBAwSoMBgikSK1CBk4wceZVaMAAKqG1eAKyUZxay6BsLwVUy5mXwBQFoDqEYyE2hyAL0EUCAxCUGFDnjkrQUEIKPYnCJLwMUCWYlkMZWUIoWlgVFxHKOAzqqOJlDIMWAAAYU2xjQRdtJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/membership/calendar.png
// module id = 1799
// module chunks = 0